import { calculateDistanceInKmBetweenCoordinates } from "@repo/map-helpers";
import { getDistanceBetweenCoordinatesWithPathAsync } from "@repo/map-helpers/src/calculateDistanceInKmBetweenCoordinates";
import { Position } from "geojson";
import { useEffect, useState } from "react";

export function useDistance({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}) {
  const [distance, setDistance] = useState<string | null>(null);
  const [coordinates, setCoordinates] = useState<Position[] | null>(null);

  useEffect(() => {
    function handleUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (p: GeolocationPosition) =>
            calculateDistance(p.coords.latitude, p.coords.longitude),
          () => console.error("Unable to retrieve your location")
        );
      } else {
        console.error("Geolocation not supported");
      }
    }
    async function calculateDistance(
      userLatitude: number,
      userLongitude: number
    ) {
      const [distance_data, coordinates] =
        await getDistanceBetweenCoordinatesWithPathAsync(
          [userLongitude, userLatitude],
          [longitude, latitude]
        );
      const distance = new Intl.NumberFormat("en-EN", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(distance_data);
      setDistance(distance);
      setCoordinates(coordinates);
    }
    handleUserLocation();
  }, [latitude, longitude]);

  return [distance, coordinates] as const;
}
